<div class="container-fluid h-100 d-flex justify-content-center align-items-center flex-column login-container">
  <div class="row justify-content-center mt-5 mb-3">
    <img *ngIf="domain?.logoUrl" class="navbar-brand__img-l login-logo" [attr.src]="domain?.logoUrl" alt="Brand Logo" />
  </div>

  <div class="login-content login-toastr-container">
    <div class="toastr-relative toastr-sm toastr-no-shadow mb-1" toastContainer></div>
  </div>
  <div class="login-content login-toastr-container">
    <div class="toastr-relative toastr-sm toastr-no-shadow mb-1" toastContainerAuth0Disclaimer></div>
  </div>

  <div class="login-content login-toastr-container" *ngIf="displayfastSmsMigrated">
    <div class="toastr-relative toastr-sm toastr-no-shadow mb-1" toastContainerFastSmsMigrated></div>
  </div>
  
  <ng-template #modalReset let-c="close" let-d="dismiss">
    <wsb-modal
      (primary)="modalResetForm()"
      primaryButtonText="login_passreset_submit"
      cancelButtonText="login_passreset_back"
      cancelButtonEnable="true"
      [primaryDisabled]="resetForm.invalid"
      (dismiss)="d()"
      title="{{ 'login_passreset_title' | translate }}"
    >
      <div body>
        <p [innerHTML]="'login_passreset_intro' | translate"></p>
        <form [formGroup]="resetForm">
          <!--          <label for="reset_username" translate>account_username</label>-->
          <input
            type="text"
            id="reset_username"
            placeholder="{{ getLabelUsername() | translate }}"
            formControlName="username"
            name="username"
            class="form-control  form-control--short"
          />
          <wsb-validation-error-msg [fc]="resetForm.get('username')"></wsb-validation-error-msg>
        </form>
      </div>
    </wsb-modal>
  </ng-template>
  <div class="row">
    <div class="col">
      <div class="card card-login pb-2 login-content" *ngIf="!isExpiredPwd">
        <div class="card-body">
          <form class="form" role="form" (ngSubmit)="login()" [formGroup]="loginForm">           
            <div class="form-group">
              <label class="username-label" for="username">{{ getLabelUsername() | translate }}</label>
              <input
                type="text"
                class="form-control"
                name="username"
                id="username"
                placeholder="{{ getLabelUsername() | translate }}"
                formControlName="username"
                #username
              />
            </div>
            <div class="form-group password-line">
              <label for="password">Password</label>
              <input
                [type]="showPassword ? 'text' : 'password'"
                class="form-control"
                name="password"
                id="password"
                placeholder="Password"
                formControlName="password"
              />
              <wsb-atlas-button
                variant="icon"
                [icon]="faPasswordIconShow"
                roundButton=""
                size="sm"
                noHover="true"
                (click)="showHidePassWord()"
              >
              </wsb-atlas-button>
            </div>
            <div class="form-check" hidden>
              <label class="form-check-label" for="rememberMe">
                <input class="form-check-input" type="checkbox" name="rememberMe" id="rememberMe" formControlName="rememberMe" />
                <span>Remember me</span>
              </label>
            </div>
            <wsb-atlas-button
              class="d-block"
              [loading]="loading"
              [label]="'login_loginbtn'"
              [roundButton]="true"
              buttonType="submit"
            ></wsb-atlas-button
            ><br />
            <wsb-atlas-button
              class="d-block mt-2"
              *ngIf="domain && domain.canResetPassword"
              [label]="'login_forgotpass_link'"
              variant="link"
              (btnClick)="openModalReset()"
            ></wsb-atlas-button>
            <wsb-atlas-button
              class="d-block"
              *ngIf="domain && domain.canRegister"
              [label]="'login_register_link'"
              variant="link"
              routerLink="/register"
            ></wsb-atlas-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="login_disclaimer" *ngIf="displayDisclaimer()">
  <span [innerHTML]="'login_disclaimer' | translate"></span>
</div>
<ng-template #modalExpirePWD let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="btnModalExpirePWD()"
    primaryButtonText="login_passreset_submit"
    (dismiss)="d()"
    title="{{ 'login_passreset_expired_title' | translate }}"
  >
    <div body>
      <h5 class="accoutExpiredPwd">{{ accoutExpiredPwd }}</h5>
      <p>{{ 'login_passreset_expired_intro' | translate }}</p>
      <!-- <input type="text" id="exipre_pwd"  [formControl]="accoutExpiredPwd" name="accountExpired"  readonly = true class="form-control  form-control--short" style="opacity: 1.35" /> -->
    </div>
  </wsb-modal>
</ng-template>
